import BulkUploadPdf from 'src/components/common/bulkUpload/BulkUploadPdf';
import Box from '@mui/material/Box';

const Index = () => {
  const handleClose = () => {
    console.log('handle close cancel');
  };
  return (
    <Box p={'20px'} pt={'0'} width={'100%'} bgcolor={'primary.light'}>
      <BulkUploadPdf handleClose={handleClose} columnMd={2} allFile={true}/>
    </Box>
  );
};

export default Index;
